<template>
  <v-app class="split-bg">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <h1 class="admin mb-4">{{ adminLogin }}</h1>
                  <v-img
                    :src="settings.branding.logo"
                    alt="Vue Material Admin"
                    max-width="266"
                    max-height="200"
                  />
                </div>
                <v-form>
                  <v-text-field
                    class="mt-8"
                    v-model="user.email"
                    type="text"
                    append-icon="person"
                    label="Login"
                    placeholder=""
                  />
                  <v-text-field
                    v-model="user.password"
                    append-icon="lock"
                    label="Password"
                    type="password"
                    placeholder=""
                  />
                </v-form>
              </v-card-text>
              <v-spacer />
              <v-btn block color="primary" :loading="loading" @click="login"
                >Login</v-btn
              >
              <v-flex>
                <v-card-text>
                  Forgot password? Reset it
                  <router-link :to="{ name: forgotPassword }">here</router-link>
                </v-card-text>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { User, Associate } from "@/classes";
import settingsMixin from "../../mixins/settingsMixin";

export default {
  name: "ResetPassword",
  mixins: [settingsMixin],
  data() {
    return {
      loading: false,
      user: {
        email: null,
        password: null,
      },
    };
  },
  created() {
    console.log("Hello Horld!");
    localStorage.removeItem("token");
  },
  computed: {
    forgotPassword() {
      const routeName = this.$route.name;
      return routeName === "UserLogin"
        ? "UserForgotPassword"
        : "AssociateForgotPassword";
    },
    adminLogin() {
      const routeName = this.$route.name;
      return routeName === "AssociateLogin" ? "ADMIN LOGIN" : "";
    },
  },
  methods: {
    login() {
      this.loading = true;
      const { user } = this;
      const routeName = this.$route.name;
      if (routeName === "UserLogin") {
        User.login(user)
          .then(() => {
            this.$router.push({ name: "Dashboard" });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error!",
              text: "Wrong email or password",
              icon: "error",
            });
          });
      } else if (routeName === "AssociateLogin") {
        Associate.login(user)
          .then(() => {
            this.$router.push({ name: "AssociateDashboard" });
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
            this.$swal({
              title: "Error!",
              text: "Wrong email or password",
              icon: "error",
            });
          });
      }
    },
  },
};
</script>

<style scoped>
.split-bg {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

.admin {
  color: red;
}
</style>
